import {
    server
} from "@/api";

const prefix = 'api/me'






export const companies = async (params = {}) => {
    return await server().get(`${prefix}/companies`, { params });
}

export const actAsCompany = async (companyId) => {
    return await server().post(`${prefix}/act-as-company/${companyId}`);
}

export const stopActingAsCompany = async () => {
    return await server().post(`${prefix}/stop-acting-as-company`);
}


const meApi = {
    companies,
    actAsCompany,
    stopActingAsCompany
}

export default meApi;